import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPro from './reducers/pro.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ProEffects } from './effects/pro.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('calculateProNodes', fromPro.CalculateProNodesReducer),
    StoreModule.forFeature('proNodesBank', fromPro.ProNodesBankReducer),
    EffectsModule.forFeature([ProEffects])
  ]
})
export class ProModule { }
